import React from "react";
import tokenService from '../../../../utils/tokenDecoder';
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';
export default class ComponentToPrint extends React.Component {
    render() {
        const StockBalanceDetails = this.props.StockBalanceDetails;
        const SearchData = this.props.SearchData;
        const StockBalanceReportInput = this.props.StockBalanceReportInput;
        return (
            <div>
                <h2><center><u>Available GRN Report</u></center></h2>
                <div>&nbsp;</div>
                <h5><center>Group :{SearchData.groupName} </center></h5>
                <h5><center>Factory :{SearchData.factoryName} </center></h5>
                <h5><center>Item Category :{SearchData.categoryName===undefined?"All Categories": (SearchData.categoryName)} </center></h5>
                <h5><center>Factory Item :{SearchData.factoryItem===undefined?"All Items": (SearchData.factoryItem)}  </center></h5>
                <div>&nbsp;</div>
                <h2><center>{StockBalanceReportInput.date}</center></h2>
                <div>
                    <Box minWidth={1000}>
                        <TableContainer style={{ width: '100%' }}>
                            <Table aria-label="caption table" style={{ width: '100%' }} size="small" >
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Item Category</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Factory Item</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>GRN Number</TableCell>
                                        <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Supplier</TableCell>
                                        <TableCell align={'right'} style={{ border: "1px #ccc solid" }}>Quantity</TableCell>
                                        <TableCell align={'right'} style={{ border: "1px #ccc solid" }}>Unit Price (LKR)</TableCell>
                                        <TableCell align={'right'} style={{ border: "1px #ccc solid"}}>Total Price (LKR)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {StockBalanceDetails.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                                {data.categoryName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                                {data.itemName}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{  border: "1px #ccc solid"  }}>
                                                {data.grnNumber}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{  border: "1px #ccc solid"  }}>
                                                {data.supplierName}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{  border: "1px #ccc solid"  }}>
                                                {data.quantity}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid"  }}>
                                                {data.unitPrice.toFixed(2)}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{  border: "1px #ccc solid" }}>
                                                {(data.quantity * data.unitPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>
        );
    }
}